import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonLabel } from "@ionic/react";

import "../Shared.css";
import "../../App.css";
import "./AppHeader.css";
import jrcalcLogo from "../assets/logo_jrcalc@2x.png";
import aaceLogo from "../assets/logo_AACE@2x.png";
import responderLogo from "../assets/Logo_Responder_Star@3x.png";
import { IScreenProps, IUser } from "../Interfaces";
import DataController from "../controllers/DataController";

type Props = {
  app: IScreenProps["app"];
  trust: string | null | undefined;
};
type State = {};

class AppHeader extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    let backgroundColor = "var(--icpg-blue-30)";

    let trustImageSource = null;

    if (this.props.trust != null) {
      trustImageSource = DataController.getTrustImage(this.props.trust, this.props.app);
    }

    if (this.props.app === "iCPG") {
      return (
        <div className="appHeaderiCPGContainer" style={{ height: 76, backgroundColor: backgroundColor }}>
          <div>
            <img className="appHeaderICPGJrcalcLogo" alt="JRCALC logo" src={jrcalcLogo} />
            <div className="appHeaderICPGHeaderText">Clinical Practice</div>
            <div className="appHeaderICPGHeaderText">Guidelines</div>
          </div>
          <div className="appHeaderICPGaaceLogoContainer">
            <img className="aaceLogo" alt="AACE logo" src={aaceLogo} />
          </div>
        </div>
      );
    } else if (this.props.app === "Plus") {
      return (
        <div
          className={`appHeaderPlusContainer ${this.props.trust}`}
          style={{ backgroundColor: "var(--category-default)" }}
        >
          <div className="globalContentMargin appHeaderPlusContent">
            {trustImageSource != null ? (
              <img className="appHeaderPlusTrustLogo" alt={`${this.props.trust} logo`} src={trustImageSource} />
            ) : (
              <img className="aaceLogoPlus" alt="AACE logo" src={aaceLogo} />
            )}
            <div className="appHeaderPlusSeparator" />
            <img className="appHeaderPlusJrcalcLogo" alt="JRCALC logo" src={jrcalcLogo} />
          </div>
        </div>
      );
    } else {
      return (
        <div className={`appHeaderCFRContainer`}>
          <div className="globalContentMargin appHeaderCFRContent">
            <div className="appHeaderCFRResponderContainer">
              <img className="responderLogo" alt="Responder Plus logo" src={responderLogo} />

              <div className="appHeaderCFRFrontContent">
                <div className="appHeaderResponderText">RESPONDER</div>
                <div className="appHeaderResponderPlusText">PLUS</div>
              </div>

              <div className="appHeaderCFRFrontContentCompact">
                <div className="appHeaderResponderText">R</div>
                <div className="appHeaderResponderPlusText">P</div>
              </div>
            </div>

            <div className="appHeaderResponderTrustLogoContainer">
              {trustImageSource != null ? (
                <img className="appHeaderResponderTrustLogo" alt={`${this.props.trust} logo`} src={trustImageSource} />
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
      );
    }
  }
}

export default AppHeader;
